<mat-form-field class="filter__select_full" appearance="outline">
  <input matInput
    placeholder="{{placeholder}}"
    [matAutocomplete]="auto"
    [value]="selectedOption.value"
    (input)="onChange($any($event.target).value)"
    (blur)="onTouched(); blur.emit();"
  >
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option.value" [id]="option.id">
      {{option.value}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
